import { Link } from 'react-router-dom';
import { articles } from '@/mocks/data';

export default function LatestUpdates() {
  const latest = [...articles].sort((a, b) => new Date(b.publishDate).getTime() - new Date(a.publishDate).getTime()).slice(0, 6);

  const categoryMap: Record<string, string> = {
    announcements: '官方公告',
    resources: '资源下载',
    community: '社区动态',
    tutorials: '创作教程',
    membership: '会员专区',
  };

  return (
    <section className="py-14 md:py-20 px-4 md:px-6 bg-background-100">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-12">
          <div className="flex items-center justify-center gap-2 mb-4">
            <span className="w-8 h-px bg-accent-400/60"></span>
            <span className="text-accent-600 text-sm tracking-widest font-label uppercase">
              最新动态
            </span>
            <span className="w-8 h-px bg-accent-400/60"></span>
          </div>
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950">
            近期更新
          </h2>
          <p className="text-foreground-500 text-sm mt-3 max-w-md mx-auto">
            浏览琉璃神社最新发布的文章与资源，发现更多精彩内容
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
          {latest.map((article) => (
            <Link
              key={article.id}
              to={`/article/${article.id}`}
              className="flex gap-4 bg-background-50 rounded-lg p-4 border border-background-200/70 hover:border-primary-200 transition-all duration-300 group"
            >
              <div className="w-24 h-24 flex-shrink-0 rounded-lg overflow-hidden">
                <img
                  src={article.coverImage}
                  alt={article.title}
                  title={`${article.title} - 琉璃神社官方`}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
              </div>
              <div className="flex-1 min-w-0">
                <div className="flex items-center gap-2 mb-1">
                  <span className="text-xs text-secondary-600 bg-secondary-100 px-2 py-0.5 rounded-full font-medium">
                    {categoryMap[article.category] || article.category}
                  </span>
                </div>
                <h3 className="font-heading font-semibold text-foreground-950 group-hover:text-primary-500 transition-colors text-sm leading-snug line-clamp-2 mb-1">
                  {article.title}
                </h3>
                <span className="text-foreground-400 text-xs">{article.publishDate}</span>
              </div>
            </Link>
          ))}
        </div>

        <div className="text-center mt-10">
          <Link
            to="/category/announcements"
            className="inline-flex items-center gap-2 px-6 py-2.5 rounded-full border-2 border-primary-500 text-primary-500 font-semibold hover:bg-primary-500 hover:text-white transition-colors whitespace-nowrap text-sm"
          >
            浏览全部文章
            <div className="w-4 h-4 flex items-center justify-center">
              <i className="ri-arrow-right-line text-xs"></i>
            </div>
          </Link>
        </div>
      </div>
    </section>
  );
}